import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://www.lutrom.co.uk";
const DEFAULT_IMAGE = `${SITE}/gallery/lutrom-machines.jpg`;

const Seo = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
}) => {
  const url = `${SITE}${path}`;
  const fullTitle = title
    ? `${title} | Lutrom Engineering`
    : "Lutrom Engineering | 24/7 Mechanical & Electrical Engineers, North West England";

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Lutrom Engineering" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
